"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const ValueBandsToolTip_1 = __importDefault(require("@Components/MatchComponents/ValueBandsToolTip"));
const MatchingHeaderLabels = (props) => (react_1.default.createElement("div", { className: "header-labels" },
    react_1.default.createElement("p", null, "ISRC"),
    react_1.default.createElement("p", null, "Recording Title"),
    react_1.default.createElement("p", null, "Recording Artist"),
    react_1.default.createElement("p", null, "Writer(s)"),
    react_1.default.createElement("div", { className: "with-tooltip" },
        react_1.default.createElement("p", null, "Source"),
        react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("b", null, "H"),
                " = Historical Unmatched ",
                react_1.default.createElement("br", null),
                "These unmatched royalties were generated before January 1, 2021. ",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("b", null, "B"),
                " = Blanket License ",
                react_1.default.createElement("br", null),
                "These unmatched royalties were generated on or after January 1, 2021.") })),
    react_1.default.createElement("div", { className: "with-tooltip" },
        react_1.default.createElement("p", null, "Estimated Value"),
        react_1.default.createElement(ValueBandsToolTip_1.default, { inverseColor: false })),
    react_1.default.createElement("p", { id: "selected-count", className: `${props.selectedListLength === 0 ? 'greyed' : ''}` },
        props.selectedListLength,
        " Selected")));
exports.default = MatchingHeaderLabels;
